import { useEffect } from "react";
import { useAuthStore } from "@/stores/authStore";

export function useAuth() {
  const { user, isLoading, isRestored, restoreSession } = useAuthStore();

  useEffect(() => {
    if (!isRestored) {
      restoreSession();
    }
  }, [isRestored, restoreSession]);

  return { user, isLoading, isAuthenticated: !!user, isRestored };
}
